import React from 'react';
import { ListItem } from '@mui/material';
import { ListItemText } from 'c-components';
import { Translate } from 'c-translation';
import type { TabWrapperSettings } from 'c-types';
import { IfHasAllPermissions } from 'c-auth-module/Components';

type Tab = TabWrapperSettings['tabs'][number];

interface TabsListProps {
    filteredTabs: TabWrapperSettings['tabs'];
    selectedTab: string | null;
    onTabClick: (urlName: string, e: React.MouseEvent<HTMLAnchorElement>) => void;
    getTabHref: (urlName: string) => string;
    renderAfterTab?: (tab: Tab) => React.ReactNode;
}

const TabsList: React.FC<TabsListProps> = ({
    filteredTabs,
    selectedTab,
    onTabClick,
    getTabHref,
    renderAfterTab,
}) => (
    <>
        {filteredTabs.map(tab => (
            <React.Fragment key={tab.urlName}>
                <ListItem
                    button
                    component="a"
                    href={tab.disabled ? undefined : getTabHref(tab.urlName)}
                    selected={selectedTab === tab.urlName}
                    onClick={e => {
                        if (tab.disabled) {
                            e.preventDefault();
                            return;
                        }
                        onTabClick(tab.urlName, e);
                    }}
                >
                    <ListItemText
                        primary={
                            <IfHasAllPermissions permissions={tab.permissions}>
                                {typeof tab.title === 'string' ? (
                                    <Translate path={tab.title as any} />
                                ) : (
                                    tab.title
                                )}
                            </IfHasAllPermissions>
                        }
                    />
                </ListItem>

                {renderAfterTab?.(tab)}
            </React.Fragment>
        ))}
    </>
);

export default TabsList;
